
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const dva500: IProductData = {
  id: "hazelriggindustries-dva",
  name: "Hazelrigg Industries DVA",
  description: "DVA Vacuum Tube Microphone Preamplifier/DI",
  specialOrder: true,
  images: ["/img/hazelriggindustries_dva_front.jpg", "/img/hazelriggindustries_dva_side.png"],
  details: [{
    label: "Description",
    markdown: `
The DVA is a hybrid microphone preamplifier based on the Hazelrigg Industries VLC and D.W. Fearn VT-2 preamp.  
Utilizing a single 6072a vacuum tube, the input circuitry matches the VLC/VT-2 input stage exactly and features transformers in both the input and output stages.  

Make-up gain is provided by a low-THD/high output solid state signal path (as opposed to the vacuum tube circuits in the VLC/VT-2) due to the module size and power supply limitations inherent in the 500 series format.  
Total gain available is approximately 60db.  

User tips: Many condensers have a high output and require an input pad to avoid overloading the input transformer.  
If needed, we suggest using the pad on the microphone if available.  

Users looking for ‘saturation’ can try engaging the -20 db pad and sending the DVA an attenuated signal, then adjust gain for tone and output.  
`
  }, {
    label: "Features",
    markdown: `
- Vacuum Tube Microphone Preamp
- Vacuum Tube DI (6072a)
- Amplifier Designed By D.W. Fearn
- 1 Year Warranty
- Transformers in Both Input and Output Stages
- Front Panel Microphone/Instrument Input
- Output Indicator LED
- Polarity Reversal Switch
- -20dB Pad Switch
- +48V Phantom Power Switch with LED indicator
- High Pass Filter Switch
    `
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.hazelriggindustries.com/hazelriggdseries" target="_blank">https://www.hazelriggindustries.com/hazelriggdseries</a>
- <a to="https://static1.squarespace.com/static/610da5f698ae9050ada60fb8/t/670524bc3dbf934c5a519711/1728390332954/D+series+manuals.pdf" target="_blank">Manual</a>
    `
  }],
  videos: [],
  metadata: {
    hashtags: [HASHTAGS.LIVE_SOUND, HASHTAGS.MIXING, HASHTAGS.RECORDING, HASHTAGS.API_500, HASHTAGS.SINGLE_SLOT, HASHTAGS.MICPRE],
    manufacturer: BRAND.HAZELRIGG,
  }
}